import {
  Routes,
  Route,
  Navigate,
  useLocation,
  matchRoutes
} from 'react-router-dom';
import './App.css';
import LoginPage from '../src/screens/auth/Login';
import RegisterPage from './screens/auth/Register';
import ForgotPassword from './screens/auth/ForgotPassword';
import OtpScreen from './screens/auth/OtpScreen';
import ResetPassword from './screens/auth/ResetPassword';
import Dashboard from './screens/dashboard/page';
import RoleDashboard from './components/RoleDashboard';
import TestRoleDashboard from './test-role-dashboard';
import TestAuthState from './test-auth-state';
import ProtectedRoutes from './components/ProtectedRoutes';
import Header from './components/header';
import Sidebar from './components/sidebar';
import Profile from './screens/profile/profile';
import Users from './screens/users/users';
import ApiKeys from './screens/systemSetup/apikeys/apikeys';
import Products from './screens/products/products';
import Branches from './screens/branches/branches';
import Customers from './screens/customers/customers';
import ViewCustomers from './screens/customers/view/view';
import VerifyEmail from './screens/customers/VerifyEmail';
import SetEmail from './screens/customers/setemail';
import SetPhone from './screens/customers/setphone';
import EditCustomers from './screens/customers/edit/edit';
import EditUserGroup from './screens/usergroups/edit/edit';
import UserGroups from './screens/usergroups/usergroups';
import CreateGroups from './screens/usergroups/create/create';
import Partners from './screens/partners/partners';
import PartnerUsers from './screens/partner-users/partner-users';
import Solicitors from './screens/solicitors/solicitors';
import CreateSolicitors from './screens/solicitors/create/create';
import EditSolicitors from './screens/solicitors/edit/edit';
import Create from './screens/users/create/create';
import EditUser from './screens/users/edit/edit';
import EditProduct from './screens/products/edit/edit';
import { NotFound } from './components/notFound';
import CreateCustomer from './screens/customers/create/create';
import CreateApiKey from './screens/systemSetup/apikeys/create/create';
import CreateProduct from './screens/products/create/create';
import CreateBranch from './screens/branches/create/create';
import EditBranch from './screens/branches/edit/edit';
import DetailBranch from './screens/branches/view';
import Tags from './screens/systemSetup/tags/tags'
import Tasks from './screens/tasks/Tasks'
import AddTags from './screens/systemSetup/tags/create/create'
import EditTags from './screens/systemSetup/tags/edit/edit'
import EditPartners from './screens/partners/edit/edit'
import LenderPanel from './screens/systemSetup/lenderPanel/lender'
import AddLenderPanel from './screens/systemSetup/lenderPanel/create/create'
import EditLenderPanel from './screens/systemSetup/lenderPanel/edit/edit'
import GroupCodes from './screens/systemSetup/groupCodes/groupCodes'
import EditGroupCodes from './screens/systemSetup/groupCodes/edit/edit'
import AddGroupCode from './screens/systemSetup/groupCodes/create/create'
import Automation from './screens/systemSetup/automation/automation'
import TaskDefinitions from './screens/systemSetup/TaskDefinitions/taskdefinitions'
import CreatTaskDefinitions from './screens/systemSetup/TaskDefinitions/create/create'
import EditTaskDefinitions from './screens/systemSetup/TaskDefinitions/edit/edit'
import CreateAutomation from './screens/systemSetup/automation/create-automation';
import EditAutomation from './screens/systemSetup/automation/edit-automation'
import {ViewSolicitors} from './screens/solicitors/view/view';
import {ViewUser} from './screens/users/view/view';
import ResetPasswordForUser from './components/common/resetPassword';
import ViewIndividualUserGroups from './screens/usergroups/view/view'
import CreatePartner from './screens/partners/create/create'
import CreatePartnerUser from './screens/partners/create-partner-user/create'
import Notes from './screens/customers/notes'
import Unauthorized from './screens/Unauthorized'
//import Reschedule from './screens/customers/Appointments/reschedule'
import Leads from './screens/leads/leads'
import ViewLeads from '../src/screens/leads/view/viewleads';
import EditLeads from './screens/leads/edit/edit';
import EditEstateAdminstration from './screens/leads/edit/editEstateAdminstration';
import EditGeneralEnquiries from './screens/leads/edit/editGeneralEnquiries';
import EditGrantApplications from './screens/leads/edit/editGrantApplications';
import EditLastingPowersOfAttorneys from './screens/leads/edit/editLastingPowersOfAttorneys';
import EditLssEstateAdministration from './screens/leads/edit/editLssEstateAdministration';
import ViewLssEstateAdministration from './screens/leads/view/viewleadLssEstateAdministration';
import ViewLeadEstateAdminstration from './screens/leads/view/viewleadEstateAdminStration';
import EditLssWills from './screens/leads/edit/editLssWills';
import ViewLssWillLead from './screens/leads/view/viewleadLssWill';
import ViewWillLead from './screens/leads/view/viewleadWill';
import ViewLeadGeneralEnquiry from './screens/leads/view/viewleadGeneralEnquiry';
import EditGeneralEnquiry from './screens/leads/edit/EditGeneralEnquiry';
import ViewLeadGrantApplication from './screens/leads/view/viewleadGrantApplication';
import ViewLssLastingPowersOfAttorneyLead from './screens/leads/view/viewleadLssLastingPowersOfAttorney';
import EditLssLastingPowersOfAttorneyForm from './screens/leads/edit/editLssLastingPowersOfAttorney';
import EditWills from './screens/leads/edit/editWills';
import ViewConveyancingLead from './screens/leads/view/viewleadConveyancing';
import ViewLeadReviewOfLegalPack from './screens/leads/view/viewleadReviewOfLegalPack';
import ViewLeadTransferOfEquity from './screens/leads/view/viewleadTransferOfEquity';
import ViewLeadFirstRegistration from './screens/leads/view/viewleadFirstRegistration';
import ViewLeadMortgageRedemption from './screens/leads/view/viewleadMortgageRedemption';
import ViewLeadRemortgage from './screens/leads/view/viewleadRemortgage';
import ViewLeadSale from './screens/leads/view/viewleadSale';
import ViewLeadSalePurchase from './screens/leads/view/viewleadSalePurchase';
import EditConveyancingSaleDetails from './screens/leads/edit/EditConveyancingSaleDetails';
import EditConveyancingTransferOfEquity from './screens/leads/edit/EditConveyancingTransferOfEquity';
import EditConveyancingPurchase from './screens/leads/edit/editConveyancingPurchase';
import EditConveyancingSalePurchase from './screens/leads/edit/EditConveyancingSalePurchase';
import EditFirstRegistration from './screens/leads/edit/EditFirstRegistration';
import SaleView from './screens/conveyancing/SaleView';
import ChangeStatus from './screens/leads/changestatus';
import ChangeGroupCode from './screens/leads/changegroupcode';
import Reorts from './screens/reports/reports'
import SetEmailCustomer from './screens/customers/setemail'
import SetPhoneCustomer from './screens/customers/setphone'
// Customer Portal
import CustomerLogin from './screens/customer-portal/CustomerLogin'
import CustomerLayout from './screens/customer-portal/CustomerLayout'
import CustomerDashboard from './screens/customer-portal/CustomerDashboard'
import MyQuotes from './screens/customer-portal/MyQuotes'
import QuoteDetail from './screens/customer-portal/QuoteDetail'
import PartnerView from './screens/partners/view/view'
import EmailTemplates from './screens/communication/emailtemplate/emailtemplate'
import SMSTemplate from './screens/communication/sms-template/smstemplate'
import CreateSMSTemplate from './screens/communication/sms-template/create-sms-template'
import EditSMSTemplate from './screens/communication/sms-template/edit-sms-template'
import MergeFieldsExplorer from './screens/communication/emailtemplate/merge-fields-explorer'
import CreateBasicEmailTemplate from './screens/communication/emailtemplate/create/basic'
import CreateAdvancedEmailTemplate from './screens/communication/emailtemplate/create/advanced'
import EditBasicEmailTemplate from './screens/communication/emailtemplate/edit/basic'
import EditAdvancedEmailTemplate from './screens/communication/emailtemplate/edit/advanced'
import ViewEmailTemplate from './screens/communication/emailtemplate/view/view'
import { EmailTheming, CreateTheme, EditTheme } from './screens/communication/email-theming'
import Manage from './screens/branches/manage';
import PartnerRateCards from './screens/partner-rate-cards/partner-rate-cards';
import PartnerRateCardsView from './screens/partner-rate-cards/view';
import {PartnerTables} from './screens/partner-rate-cards/manage-tables/tables';
import CreateAppointment from './screens/customers/Appointments/createAppoitment';
import EditAppoitment from './screens/customers/Appointments/editAppoitment'
import Reschedule from './screens/customers/Appointments/reschedule';
import CreateCustomFees from './screens/systemSetup/customeLeadfees/customeleadfees'
import AddCustomLeadFees from './screens/systemSetup/customeLeadfees/create/create'
import EditCustomLeadFees from './screens/systemSetup/customeLeadfees/edit/edit'
import CreateNote from './screens/customers/Notes/create/create'
import CreateLeadNote from './screens/leads/Notes/create/create'
import EditNote from './screens/customers/Notes/edit/edit'
import EditLeadNote from './screens/leads/Notes/edit/edit'
import SystemSetupLeadSubStatus from './screens/systemSetup/leadSubStatus/leadSubstatus'
import SystemSetupLeadCreateSubStatus from './screens/systemSetup/leadSubStatus/create/create'
import {CreateAssignLead} from './screens/assignLeads/create/create'
import CreateProductLeadView from './screens/customers-view/product-lead-view'
import EditProductLead from './screens/leads/edit/product-lead-edit'
import {Tables} from './screens/branches/manage-tables/tables';
import PurchaseDetails from './screens/conveyancing/PurchaseDetails';
import EditConveyancingForm from './screens/conveyancing/EditConveyancingForm';
import SaleDetails from './screens/conveyancing/SaleDetails';
import SalePurchaseDetails from './screens/conveyancing/SalePurchaseDetails';
import TransferOfEquityDetails from './screens/conveyancing/TransferOfEquityDetails';
import RemortgageDetails from './screens/conveyancing/RemortgageDetails';
import MortgageRedemptionDetails from './screens/conveyancing/MortgageRedemptionDetails';
import FirstRegistrationDetails from './screens/conveyancing/FirstRegistrationDetails';
import ReviewOfLegalPackDetails from './screens/conveyancing/ReviewOfLegalPackDetails';


const routesList = [
  { path: '/' },
  { path: '/login' },
  { path: '/register' },
  { path: '/forgot-password' },
  { path: '/otp' },
  { path: '/reset-password' },
  { path: '/unauthorized' },
  { path: '/dashboard' },
  { path: '/account/manage' },
  { path: '/users' },
  { path: '/tags' },
  { path: '/groupCodes' },
  { path: '/tags/create' },
  { path: '/groupCode/create' },
  { path: '/tags/edit/:id' },
  { path: '/products' },
  { path: '/customers' },
  { path: '/customer/edit/:id' },
  { path: '/customers/view/:id' },
  { path: '/customers/setEmail/:id' },
  { path: '/customers/setPhone/:id' },
  { path: '/customers/setemail' },
  { path: '/customers/setphone' },
  { path: '/customers/notes' },
  { path: '/customers/appointment/reschedule' },
  { path: '/user-groups' },
  { path: '/user-groups/create' },
  { path: '/user-groups/edit/:id' },
  { path: '/user-groups/view/:id' },
  { path: '/partners' },
  { path: '/partner-users' },
  { path: '/partner-users/create' },
  { path: '/solicitors' },
  { path: '/solicitors/view/:id' },
  { path: '/user/view/:id' },
  { path: '/solicitors/create' },
  { path: '/solicitors/edit/:id' },
  { path: '/users/create' },
  { path: '/partners/create' },
  { path: '/apiKey/create' },
  { path: '/branches/create' },
  { path: '/products/create' },
  { path: '/customers/create' },
  { path: '/users/edit/:id' },
  { path: '/products/edit/:id'},
  { path: '/partners/edit/:id'},
  {path:'/branches'},
  {path:'/apiKeys'},
  {path:'/branches/edit/:id'},
  {path:'/branches/view/:slug/:id'},
  {path:'/lenderPanels'},
  { path: '/lenderPanels/create' },
  {path:'/lenderPanels/edit/:id'},
  {path:'/groupcodes/edit/:id'},
  {path:'/reset-password/:id'},
  {path:'/partner/create'},
  { path: '/leads' },
  { path: 'leads/view/:slug/:id' },
  { path: '/partner/view/:id' },
  { path: '/leads/estate-administration/edit/:product_id/:lead_id' },
  { path: '/leads/editGeneralEnquiries' },
  { path: '/leads/editGrantApplications' },
  { path: '/leads/editLastingPowersOfAttorneys' },
  { path: '/leads/view/lss-estate-administration/:lead_id' },
  { path: '/leads/edit/lss-estate-administration/:lead_id' },
  { path: '/leads/view/conveyancing/:lead_id' },
  { path: '/leads/view/review-of-legal-pack/:lead_id' },
  { path: '/leads/view/first-registration/:lead_id' },
  { path: '/leads/view/mortgage-redemption/:lead_id' },
  { path: '/leads/view/remortgage/:lead_id' },
  { path: '/leads/view/sale/:lead_id' },
  { path: '/leads/view/purchase-sale/:lead_id' },
  { path: '/leads/view/sale-purchase/:lead_id' },
  { path: '/leads/edit/conveyancing/:lead_id' },
  { path: '/leads/edit/conveyancing-sale/:lead_id' },
  { path: '/leads/edit/conveyancing-purchase/:lead_id' },
  { path: '/leads/edit/conveyancing-sale-purchase/:id' },
  { path: '/leads/edit/first-registration/:lead_id' },
  { path: '/leads/editLssWills' },
  { path: '/leads/editWills' },
  { path: '/leads/view/will/:id' },
  { path: '/leads/edit/will/:id' },
  { path: '/leads/view/general-enquiry/:id' },
  { path: '/leads/edit/general-enquiry/:lead_id' },
  { path: '/leads/view/grant-application/:id' },
  { path: '/leads/view/lss-grant-application/:id' },
  { path: '/leads/grant-application/edit/:product_id/:lead_id' },
  { path: '/leads/lss-grant-application/edit/:product_id/:lead_id' },
  { path: '/leads/view/lss-will/:id' },
  { path: '/leads/edit/lss-will/:id' },
  { path: '/leads/view/lss-lasting-powers-of-attorney/:lead_id' },
  { path: '/leads/view/lss-lasting-powers-of--attorney/:lead_id' },
  { path: '/leads/edit/lss-lasting-powers-of-attorney/:lead_id' },
  { path: '/leads/edit/lss-lasting-powers-of--attorney/:lead_id' },
  { path: '/leads/edit/estate-administration/:lead_id' },

  { path: '/leads/changestatus' },
  { path: '/leads/changegroupcode' },
  { path: '/reports' },
  { path: '/automation' },
  { path: '/automation/create/:productType?' },
  { path: '/automation/edit/:id/:productType?' },
  { path: '/emailtemplates' },
  { path: '/smstemplates' },
  { path: '/sms-templates' },
  { path: '/sms-templates/create' },
  { path: '/sms-templates/edit/:id' },
  { path: '/emailtemplates/merge-fields-explorer' },
  { path: '/emailtemplates/createbasic' },
  { path: '/emailtemplates/createadvanced' },
  { path: '/emailtemplates/edit/:id' },
  { path: '/emailtemplates/edit/advanced/:id' },
  { path: '/emailtemplates/view/:id' },
  { path: '/communication/email-theming' },
  { path: '/communication/email-theming/create' },
  { path: '/communication/email-theming/edit/:id' },
  { path: '/branch/manage/:slug/:title' },
  { path: '/partner-rate-cards' },
  { path: '/partner-rate-cards/view/:id' },
  { path: '/partner-rate-cards/manage/:id/:title' },
  { path: '/customers/create/appoitment/:id' },
  { path: '/customers/edit/appoitment/:id' },
  { path: '/customers/appointment/reschedule/:id' },
  { path: '/custom/lead-fees' },
  { path: '/custom/create/lead-fees'},
  { path: '/custom/edit/lead-fees/:id'},
  { path: '/customer/create/note/:id'},
  { path: '/customer/edit/note/:id'},
  {path:'/system-setup/LeadSubStatuses'},
  {path:'/system-setup/LeadCreateSubStatuses'},
  {path:'/create/:slug/:id'},
  { path: '/customer-view/generalenquiries'},
  { path: '/customer-view/grantapplications'},
  { path: '/customer-view/lastingpowersofattorneys'},
  { path: '/customer-view/lssestateadmins'},
  { path: '/customer-view/lsswills'},
  { path: '/system-setup/taskdefinitions' },
  { path: '/system-setup/taskdefinitions/create' },
  { path: '/system-setup/taskdefinitions/edit/:id' },
  { path: '/:slug/create'},
  { path: 'leads/:slug/edit/:product_id/:lead_id'},
  { path: 'leads/note/create/:id'},
  { path: 'leads/note/edit/:id'},
  { path: '/conveyancing/purchase/:id'},
  { path: '/conveyancing/sale/:id'},
  { path: '/conveyancing/sale-purchase/:id'},
  { path: '/conveyancing/transfer-of-equity/:id'},
  { path: '/leads/view/transfer-of-equity/:lead_id'},
  { path: '/leads/edit/transfer-of-equity/:lead_id'},
  { path: '/conveyancing/remortgage/:id'},
  { path: '/conveyancing/mortgage-redemption/:id'},
  { path: '/conveyancing/first-registration/:id'},
  { path: '/conveyancing/review-of-legal-pack/:id'},
  // Customer Portal Routes
  { path: '/customer-portal/login'},
  { path: '/customer-portal/dashboard'},
  { path: '/customer-portal/my-quotes'},
  { path: '/customer-portal/quote/:lead_id'},
];

export default function App() {
  const location = useLocation();
  const matched = matchRoutes(routesList, location);

  const hideHeaderSidebarRoutes = [
    '/login',
    '/register',
    '/forgot-password',
    '/otp',
    '/reset-password',
    '/customer-portal/login',
    '/customer-portal/dashboard',
    '/customer-portal/my-quotes'
  ];

  // Check if it's a customer portal route (includes /customer-portal/)
  const isCustomerPortalRoute = location.pathname.startsWith('/customer-portal/');

  const isHeaderSidebarHidden = hideHeaderSidebarRoutes.includes(location.pathname) || isCustomerPortalRoute;
  const isNotMatched = !matched;

  if (isNotMatched) {
    return <NotFound />;
  }

  return (
    <div className="app">
      {!isHeaderSidebarHidden && <Header />}
      <div className="wrapper">
        {!isHeaderSidebarHidden && <Sidebar />}
        <main className="main">
          <Routes>

            {/* Public Routes start */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="otp" element={<OtpScreen />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="verify-email" element={<VerifyEmail />} />
            <Route path="unauthorized" element={<Unauthorized />} />
            <Route path="test-dashboard" element={<TestRoleDashboard />} />
            <Route path="test-auth" element={<TestAuthState />} />
            <Route path="role-dashboard-unprotected" element={<RoleDashboard />} />

            {/* Customer Portal Routes */}
            <Route path="customer-portal/login" element={<CustomerLogin />} />
            <Route path="customer-portal" element={<CustomerLayout />}>
              <Route path="dashboard" element={<CustomerDashboard />} />
              <Route path="my-quotes" element={<MyQuotes />} />
              <Route path="quote/:lead_id" element={<QuoteDetail />} />
            </Route>
              {/* Public Routes end */}

            {/* Protected Routes start */}
               <Route element={<ProtectedRoutes />}>
              <Route path="dashboard" element={<RoleDashboard />} />
              <Route path="admin-dashboard" element={<Dashboard />} />
              <Route path="role-dashboard" element={<RoleDashboard />} />
              <Route path="account/manage" element={<Profile />} />
              <Route path="users" element={<Users />} />
              <Route path="groupCodes" element={<GroupCodes />} />
              <Route path="apiKeys" element={<ApiKeys />} />
              <Route path="customers" element={<Customers />} />
              <Route path="customers/view/:id" element={<ViewCustomers />} />
              <Route path="tasks" element={<Tasks />} />
              <Route path="users/create" element={<Create />} />
              <Route path="branches/create" element={<CreateBranch />} />
              <Route path="groupCode/create" element={<AddGroupCode />} />
              <Route path="apikey/create" element={<CreateApiKey/>} />
              <Route path="customers/create" element={<CreateCustomer />} />
              <Route path="customers/setemail" element={<SetEmail />} />
              <Route path="customers/setphone" element={<SetPhone />} />
              <Route path="customers/notes" element={<Notes />} />
              <Route path="customers/appointment/reschedule/:id" element={<Reschedule />} />
              <Route path="customer/edit/:id" element={<EditCustomers/>} />
              <Route path="groupcodes/edit/:id" element={<EditGroupCodes/>} />
              <Route path="products/create" element={<CreateProduct/>} />
              <Route path="users/edit/:id" element={<EditUser />} />
              <Route path="solicitors/view/:id" element={<ViewSolicitors/>} />
              <Route path="user/view/:id" element={<ViewUser/>} />
              <Route path="user-groups/view/:id" element={<ViewIndividualUserGroups/>} />
              <Route path="partners/edit/:id" element={<EditPartners/>} />
              <Route path="products/edit/:id" element={<EditProduct />} />
              <Route path="reset-password/:id" element={<ResetPasswordForUser />} />
              <Route path="user-groups" element={<UserGroups/>} />
              <Route path="user-groups/edit/:id" element={<EditUserGroup/>} />
              <Route path="user-groups/create" element={<CreateGroups/>} />
              <Route path="partners" element={<Partners />} />
              <Route path="partner/create" element={<CreatePartner/>} />
              <Route path="partner-users" element={<PartnerUsers />} />
              <Route path="partner-users/create" element={<CreatePartnerUser/>} />
              <Route path="tags" element={<Tags />} />
              <Route path="tags/create" element={<AddTags />} />
              <Route path="tags/edit/:id" element={<EditTags />} />
              <Route path="products" element={<Products />} />
              <Route path="solicitors" element={<Solicitors />} />
              <Route path="solicitors/create" element={<CreateSolicitors/>} />
              <Route path="solicitors/edit/:id" element={<EditSolicitors />} />
              <Route path="branches" element={<Branches />} />
              <Route path="branches/edit/:id" element={<EditBranch/>} />
              <Route path="branches/view/:slug/:id" element={<DetailBranch/>} />
              <Route path="lenderPanels" element={<LenderPanel />} />
              <Route path="lenderPanels/create" element={<AddLenderPanel />} />
              <Route path="lenderPanels/edit/:id" element={<EditLenderPanel />} />
              <Route path="customers/setEmail/:id" element={<SetEmailCustomer/>} />
              <Route path="customers/setPhone/:id" element={<SetPhoneCustomer />} />
              {/* Leads Routes */}
              <Route path="leads" element={<Leads />} />
              <Route path="leads/view/:slug/:id" element={<ViewLeads/>} />
              
              {/* LSS Will Routes */}
              <Route path="leads/view/lss-will/:id" element={<ViewLssWillLead />} />
              <Route path="leads/edit/lss-will/:id" element={<EditLssWills />} />
              
              {/* Will Routes */}
              <Route path="leads/view/will/:id" element={<ViewWillLead />} />
              <Route path="leads/edit/will/:id" element={<EditWills />} />

              {/* General Enquiry Routes */}
              <Route path="leads/view/general-enquiry/:id" element={<ViewLeadGeneralEnquiry />} />
              <Route path="leads/edit/general-enquiry/:lead_id" element={<EditGeneralEnquiry />} />

              {/* Grant Application Routes */}
              <Route path="leads/view/grant-application/:id" element={<ViewLeadGrantApplication />} />
              <Route path="leads/view/lss-grant-application/:id" element={<ViewLeadGrantApplication />} />
              <Route path="leads/grant-application/edit/:product_id/:lead_id" element={<EditGrantApplications />} />
              <Route path="leads/lss-grant-application/edit/:product_id/:lead_id" element={<EditGrantApplications />} />

              {/* LSS Lasting Powers of Attorney Routes */}
              <Route path="leads/view/lss-lasting-powers-of-attorney/:lead_id" element={<ViewLssLastingPowersOfAttorneyLead />} />
              <Route path="leads/view/lss-lasting-powers-of--attorney/:lead_id" element={<ViewLssLastingPowersOfAttorneyLead />} />
              <Route path="leads/edit/lss-lasting-powers-of-attorney/:lead_id" element={<EditLssLastingPowersOfAttorneyForm />} />
              <Route path="leads/edit/lss-lasting-powers-of--attorney/:lead_id" element={<EditLssLastingPowersOfAttorneyForm />} />
              
              {/* Estate Administration Routes */}
              <Route path="leads/view/estate-administration/:lead_id" element={<ViewLeadEstateAdminstration />} />
              <Route path="leads/edit/estate-administration/:lead_id" element={<EditEstateAdminstration />} />

              {/* LSS Estate Administration Routes */}
              <Route path="leads/view/lss-estate-administration/:lead_id" element={<ViewLssEstateAdministration />} />
              <Route path="leads/edit/lss-estate-administration/:lead_id" element={<EditLssEstateAdministration />} />
              
              {/* Conveyancing Routes */}
              <Route path="leads/view/conveyancing/:lead_id" element={<ViewConveyancingLead />} />
              <Route path="leads/view/review-of-legal-pack/:lead_id" element={<ViewLeadReviewOfLegalPack />} />
              <Route path="leads/view/first-registration/:lead_id" element={<ViewLeadFirstRegistration />} />
              <Route path="leads/view/mortgage-redemption/:lead_id" element={<ViewLeadMortgageRedemption />} />
              <Route path="leads/view/remortgage/:lead_id" element={<ViewLeadRemortgage />} />
              <Route path="leads/view/sale/:lead_id" element={<ViewLeadSale />} />
              <Route path="leads/view/purchase-sale/:lead_id" element={<ViewLeadSalePurchase />} />
              <Route path="leads/view/sale-purchase/:lead_id" element={<ViewLeadSalePurchase />} />
              <Route path="leads/view/transfer-of-equity/:lead_id" element={<ViewLeadTransferOfEquity />} />
              <Route path="leads/edit/conveyancing/:lead_id" element={<EditConveyancingForm />} />
              <Route path="leads/edit/conveyancing-sale/:lead_id" element={<EditConveyancingSaleDetails />} />
              <Route path="leads/edit/conveyancing-purchase/:lead_id" element={<EditConveyancingPurchase />} />
              <Route path="leads/edit/conveyancing-sale-purchase/:id" element={<SalePurchaseDetails />} />
              <Route path="leads/edit/transfer-of-equity/:lead_id" element={<EditConveyancingTransferOfEquity />} />
              <Route path="leads/edit/first-registration/:lead_id" element={<EditFirstRegistration />} />
            
              {/* <Route path="/leads/editGeneralEnquiries" element={<EditGeneralEnquiries />} />
              <Route path="/leads/editGrantApplications" element={<EditGrantApplications />} />
              <Route path="/leads/editLastingPowersOfAttorneyst" element={<EditLastingPowersOfAttorneys />} />
              <Route path="/leads/editLssEstateAdmins" element={<EditLssEstateAdmins />} />
              <Route path="/leads/editLssWills" element={<EditLssWills />} />
              <Route path="/leads/editWills" element={<EditWills />} /> */}

              <Route path="leads/changestatus" element={<ChangeStatus />} />
              <Route path="leads/changegroupcode" element={<ChangeGroupCode />} />
              <Route path="/partner/view/:id" element={<PartnerView/>} />
              <Route path="/automation" element={<Automation/>} />
              <Route path="/automation/create/:productType?" element={<CreateAutomation/>} />
              <Route path="/automation/edit/:id/:productType?" element={<EditAutomation/>} />
              <Route path="/emailtemplates" element={<EmailTemplates />} />
              <Route path="/emailtemplates/merge-fields-explorer" element={<MergeFieldsExplorer />} />
              <Route path="/emailtemplates/createbasic" element={<CreateBasicEmailTemplate />} />
              <Route path="/emailtemplates/createadvanced" element={<CreateAdvancedEmailTemplate />} />
              <Route path="/emailtemplates/edit/:id" element={<EditBasicEmailTemplate />} />
              <Route path="/emailtemplates/edit/advanced/:id" element={<EditAdvancedEmailTemplate />} />
              <Route path="/emailtemplates/view/:id" element={<ViewEmailTemplate />} />
              <Route path="/smstemplates" element={<SMSTemplate />} />
              <Route path="/sms-templates" element={<SMSTemplate />} />
              <Route path="/sms-templates/create" element={<CreateSMSTemplate />} />
              <Route path="/sms-templates/edit/:id" element={<EditSMSTemplate />} />

              {/* Email Theming Routes */}
              <Route path="/communication/email-theming" element={<EmailTheming />} />
              <Route path="/communication/email-theming/create" element={<CreateTheme />} />
              <Route path="/communication/email-theming/edit/:id" element={<EditTheme />} />
              
           
              <Route path="branch/manage/:slug/:title" element={<Tables/>} />
              <Route path="partner-rate-cards" element={<PartnerRateCards/>} />
              <Route path="partner-rate-cards/view/:id" element={<PartnerRateCardsView/>} />
              <Route path="partner-rate-cards/manage/:id/:title" element={<PartnerTables/>} />
              <Route path="reports" element={<Reorts />} />
              <Route path="/customers/create/appoitment/:id" element={<CreateAppointment/>} />
              <Route path="/customers/edit/appoitment/:id" element={<EditAppoitment/>} />
              <Route path="/customers/reschedule/appoitment/:id" element={<Reschedule/>} />
              <Route path="reports" element={<Reorts />} />
              <Route path="custom/lead-fees" element={<CreateCustomFees/>} />
              <Route path="custom/create/lead-fees" element={<AddCustomLeadFees/>} />
              <Route path="custom/edit/lead-fees/:id" element={<EditCustomLeadFees/>} />
              <Route path="customer/create/note/:id" element={<CreateNote/>} />
              <Route path="leads/note/create/:id" element={<CreateLeadNote/>} />
              <Route path="customer/edit/note/:id" element={<EditNote/>} />
              <Route path="leads/note/edit/:id" element={<EditLeadNote/>} />
              <Route path="system-setup/LeadSubStatuses" element={<SystemSetupLeadSubStatus/>} />
              <Route path="system-setup/LeadCreateSubStatuses" element={<SystemSetupLeadCreateSubStatus/>} />
              <Route path="create/:slug/:id" element={<CreateAssignLead />} />
              <Route path="/:slug/create" element={<CreateProductLeadView/>} />
              <Route path="leads/:slug/edit/:product_id/:lead_id" element={<EditProductLead/>} />
              <Route path="/communications/emailtemplates" element={<EmailTemplates/>} />
              <Route path="/system-setup/taskdefinitions" element={<TaskDefinitions/>} />
              <Route path="/system-setup/taskdefinitions/create" element={<CreatTaskDefinitions/>} />
              <Route path="/system-setup/taskdefinitions/edit/:id" element={<EditTaskDefinitions/>} />
              <Route path="/conveyancing/purchase/:id" element={<PurchaseDetails/>} />
              <Route path="/conveyancing/sale/:id" element={<SaleDetails/>} />
              <Route path="/conveyancing/sale-purchase/:id" element={<SalePurchaseDetails/>} />
              <Route path="/conveyancing/transfer-of-equity/:id" element={<TransferOfEquityDetails/>} />
              <Route path="/conveyancing/remortgage/:id" element={<RemortgageDetails/>} />
              <Route path="/conveyancing/mortgage-redemption/:id" element={<MortgageRedemptionDetails/>} />
              <Route path="/conveyancing/first-registration/:id" element={<FirstRegistrationDetails/>} />
              <Route path="/conveyancing/review-of-legal-pack/:id" element={<ReviewOfLegalPackDetails/>} />
              </Route> 
            {/* Protected Routes end */}

            {/* NotFound (backup) */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
